import React from 'react';
import { ButtonBase, Typography, Box } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';
import { colors } from '../../theme/theme';

interface VoteButtonProps {
  voteCount: number;
  hasVoted: boolean;
  onToggle: (e: React.MouseEvent) => void;
  disabled?: boolean;
  size?: number;
}

const VoteButton: React.FC<VoteButtonProps> = ({ voteCount, hasVoted, onToggle, disabled, size = 60 }) => (
  <ButtonBase
    onClick={onToggle}
    disabled={disabled}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      borderRadius: `${Math.round(size * 0.25)}px`,
      border: `1.5px solid ${hasVoted ? colors.primary : colors.divider}`,
      backgroundColor: hasVoted ? colors.primary : colors.background,
      boxShadow: hasVoted ? `0 6px 16px ${colors.primary}66` : 'none',
      transition: 'transform 120ms ease, background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease',
      '&:hover': {
        borderColor: colors.primary,
        backgroundColor: hasVoted ? colors.primaryDark : `${colors.primary}12`,
      },
      '&:active': {
        transform: 'scale(0.92)',
      },
    }}
  >
    <KeyboardArrowUp
      sx={{
        color: hasVoted ? '#ffffff' : colors.greyText,
        fontSize: size * 0.32,
        transition: 'transform 150ms ease',
        transform: hasVoted ? 'translateY(-1px)' : 'none',
      }}
    />
    <Box sx={{ mt: -0.5 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 800,
          fontSize: size * 0.24,
          color: hasVoted ? '#ffffff' : colors.textPrimary,
          lineHeight: 1,
        }}
      >
        {voteCount}
      </Typography>
    </Box>
  </ButtonBase>
);

export default VoteButton;
